/**
 * 结算管理详情页面
 * 创建时间：2021-11-3
 */
<template>
	<div class="float-e-margins ibox-content ibox_main tabBox" id="carRail'" ref="rescueserviceorder">
		<ul class="col-sm-12 pl0px pt0px grey_box02">
			<li class="w100px t_center active">
				<a>基本信息</a>
			</li>
		</ul>
        <div class="grey_box" >
			<div v-loading="loadingorder" element-loading-text="加载中" style="height:100%;">
				<div class="form-horizontal">
					<div class="form-group text-left">
                        <label class="col-sm-6  control-label t_left">付款单信息</label>
                    </div>
					<div class="form-group">
						<label class="col-sm-1 control-label">付款流水</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.paymentNumber" readonly>
						</div>
						<label class="col-sm-1 control-label">发送时间</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.createTime" readonly>
						</div>
                        <label class="col-sm-1 control-label">订单状态</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.paymentStatusStr" readonly>
						</div>
						<label class="col-sm-1 control-label"></label>
						<div class="col-sm-2">
							<button @click='downExport' class="btn btn-primary">下载付款单明细</button>
						</div>
					</div>
					<div class="form-group text-left">
                        <label class="col-sm-6  control-label t_left">发票信息</label>
                    </div>
					<div class="form-group">
						<label class="col-sm-1 control-label">发票号</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.invoiceNumber" readonly>
						</div>
						<label class="col-sm-1 control-label">发票代码</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.invoiceCode" readonly>
						</div>
                        <label class="col-sm-1 control-label">发票年份</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.invoiceYear" readonly>
						</div>
						<label class="col-sm-1 control-label">上传时间</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.invoiceImageTime" readonly>
						</div>
					</div>
                    <div class="form-group">
                        <label class="col-sm-1 control-label">发票照片</label>
						<div class="col-sm-11 imgBox" >
                            <div v-for='(item,index) in dataInfo.invoiceImages' v-show='dataInfo.invoiceImages.length>0' :key='index'>
                                <el-image class='imgStyle' :src="item" :preview-src-list="invoiceList"></el-image>
                            </div>
							<div>
								<button @click='openinvoiceImg' class="btn btn-primary">上传发票</button>
							</div>	
						</div>
					</div>
                    <div class="form-group text-left">
                        <label class="col-sm-6  control-label t_left">快递信息</label>
                    </div>
					<div class="form-group">
						<label class="col-sm-1 control-label">快递单号</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.packageNumber" readonly>
						</div>
						<label class="col-sm-1 control-label">上传时间</label>
						<div class="col-sm-2">
							<input type="text" class="form-control" v-model="dataInfo.packageImageTime" readonly>
						</div>
					</div>
                    <div class="form-group">
						<label class="col-sm-1 control-label">快递单照片</label>
						<div class="col-sm-11 imgBox">
                            <div v-for='(item,index) in dataInfo.packageImages' v-show='dataInfo.packageImages.length>0' :key='index'>
                                <el-image class='imgStyle' :src="item" :preview-src-list="packageImagesList"></el-image>
                            </div>
							<div>
								<button @click='openpackageImg' class="btn btn-primary">上传快递</button>
							</div>	
						</div>
					</div>
			    </div>		
			</div>
        </div>
		<!-- 上传发票 -->
		<tab-modal ref="modal1" size="large" :scroll='scrollTop' title="上传发票" v-on:cancel="confirm">
			<div class='invoiceformBox'>
				<el-form ref="invoiceform" :rules="invoicerules" :model="invoiceform" label-width="130px" class="demo-ruleForm">
					<el-form-item label="发票号" prop='invoiceNumber'>
						<el-input v-model="invoiceform.invoiceNumber" size='small' placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="发票代码" prop='invoiceCode'>
						<el-input v-model="invoiceform.invoiceCode" size='small' placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="发票年份" prop='invoiceYear'>
						 <el-date-picker v-model="invoiceform.invoiceYear" size='small' value-format='yyyy' type="year" placeholder="请输入"></el-date-picker>
					</el-form-item>
					<el-form-item label="发票照片" prop='invoiceImages'>
						<el-upload
						:action="picUrl"
						:headers="{'access-token':this.accesstoken}"
						list-type="picture-card"
						:limit='3'
						:on-preview="invoicePreview"
						:on-success='invoiceSuccess'
						:before-upload="beforeupload"
						:file-list="invoicefilelist"
						:on-exceed="imgExceed"
						:on-remove="invoiceRemove"
						>
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">请上传小于1M的照片</div>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<button @click="closeModal('modal1')" class="btn btn-primary">取消</button>
				<button @click="submitForm('invoiceform')" class="btn btn-primary">确定</button>
			</div>
		</tab-modal>
		<el-dialog :append-to-body='true' :visible.sync="invoiceVisible">
			<img width="100%" :src="invoiceImageUrl" alt="">
		</el-dialog>
		<!-- 上传快递信息 -->
		<tab-modal ref="modal2" size="large" :scroll='scrollTop' title="上传快递信息" v-on:cancel="confirm2">
			<div class='invoiceformBox'>
				<el-form ref="packageform" :rules="packageules" :model="packageform" label-width="130px" class="demo-ruleForm">
					<el-form-item label="快递号" prop='packageNumber'>
						<el-input size='small' v-model="packageform.packageNumber" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="快递单照片" prop='packageImages'>
						<el-upload
						:action="picUrl"
						:headers="{'access-token':this.accesstoken}"
						:on-preview="packagePreview"
						list-type="picture-card"
						:limit='3'
						:on-success='packageSuccess'
						:before-upload="beforeupload"
						:on-exceed="imgExceed"
						:file-list="packagefilelist"
						:on-remove="packageRemove"
						>
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">请上传小于1M的照片</div>
						</el-upload>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
				<button @click="submitForm('packageform')" class="btn btn-primary">确定</button>
			</div>
		</tab-modal>
		<el-dialog :append-to-body='true' :visible.sync="packageVisible">
			<img width="100%" :src="packageImageUrl" alt="">
		</el-dialog>
		<!-- 错误弹窗 -->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
		<div slot="footer">
				<button @click="closeModalMsg" class="btn btn-primary">确定</button>
			</div>
		</tab-modal>   
	</div>
</template>
<script>
	import { zh } from 'flatpickr/dist/l10n/zh'
import TabModal from 'components/common/TabModal'
import SubPage from 'components/common/SubPage'
import { SAVE_ENSURE, OPERATE_EXCEPTION } from 'static/message'
import { required, maxLength } from 'vuelidate/lib/validators'
import Datepicker from 'components/common/datepicker/Datepicker'
import PageRescueServiceOrderLocate from 'components/pages/rescueservice/PageRescueServiceOrderLocate'
import {deepCopy} from 'util/util'
import classlist from 'util/classlist'
import Pagination from 'components/common/Pagination'
import Mock from 'mockjs'
import RescueOrderPics from 'components/common/RescueOrderPics'
export default{
	  name: 'PageRescueServiceOrderEdit',
	  components: {
	    Datepicker,
	    TabModal,
	    SubPage,
	    Pagination,
	    PageRescueServiceOrderLocate,
	    RescueOrderPics
	  },
	  data () {  
	    return {
            loadingorder:false,
			scrollTop: '0',
			messageStr:'',
            listId:null,
            dataInfo:{
                paymentNumber:'',
                createTime:'',
                paymentStatusStr:'',
                invoiceNumber:'',
                invoiceCode:'',
                invoiceYear:'',
                invoiceImageTime:'',
                invoiceImages:[],
                packageNumber:'',
                packageImageTime:'',
				packageImages:[]
            },
            invoiceList:[],
			packageImagesList:[],
			invoiceform:{
				invoiceNumber:'',
				invoiceCode:'',
				invoiceYear:'',
				invoiceImages:''
			},
			invoicerules: {
				invoiceNumber: [
					{ required: true, message: '请输入发票号', trigger: 'blur' },
					{ max: 30, message: '最多输入30个字符', trigger: 'blur' }
				],
				invoiceCode: [
					{ required: true, message: '请输入发票代码', trigger: 'blur' },
					{ max: 30, message: '最多输入30个字符', trigger: 'blur' }
				],
				invoiceYear: [
					{ required: true, message: '请选择或输入发票年份', trigger: 'blur' }
				],
				invoiceImages: [
					{ required: true, message: '请上传发票照片', trigger: 'change' }
				]
			},
			picUrl:process.env.API_INSURANCE_ROOT +"/rescue-api/photo/upload",
			packageform:{
				packageNumber:'',
				packageImages:''
			},
			packageules: {
				packageNumber: [
					{ required: true, message: '请输入发票号', trigger: 'blur' },
					{ max: 30, message: '最多输入30个字符', trigger: 'blur' }
				],
				packageImages: [
					{ required: true, message: '请上传发票照片', trigger: 'change' }
				]
			},
			packageImageUrl:'',
			packageVisible:false,
			invoiceImageUrl:'',
			invoiceVisible:false,
			invoicefilelist:[],
			packagefilelist:[]
	    }
	  },
	  computed: {
		accesstoken:function(){
			return this.$store.state.user.accesstoken
		},
	  },
	  watch: {
	   
	  },
      mounted(){
          this.listId = this.$route.query.id
          this.detailInfo()
      },
	  created () {
		  
	  },
	  methods: {
		//下载付款单明细
		downExport(){
			this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/payment/orders/export/'+this.listId, {headers: this.token}).then(res => {
                if (res.body.success) {
						let str = res.body.data;
						var path = process.env.EXPORT_PATH;
					    var api = process.env.API_ROOT;
						var fileName = path + api + '/noauth/export?url=' + str
		    			var elemIF = document.createElement("iframe");   
				      	elemIF.src = fileName;   
				        elemIF.style.display = "none";   
				        document.body.appendChild(elemIF); 
                } else {
                    this.openMsgTip(res.body.message)
                    this.loadingorder = false
                }
            }, res => {
                this.openMsgTip(res.body.message)
                this.loadingorder = false
            })
		},
		//详情信息
        detailInfo(){
            this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/payment/detail/'+this.listId, {headers: this.token}).then(res => {
                if (res.body.success) {
                    let dataInfo = res.data.data
                    let detailInfo = this.dataInfo
                    this.invoiceList = []
                    detailInfo.paymentNumber = dataInfo.paymentNumber
                    detailInfo.createTime = dataInfo.createTime
                    detailInfo.paymentStatusStr = dataInfo.paymentStatusStr
                    detailInfo.invoiceNumber = dataInfo.invoiceNumber
                    detailInfo.invoiceCode = dataInfo.invoiceCode
                    detailInfo.invoiceYear = dataInfo.invoiceYear
                    detailInfo.invoiceImageTime = dataInfo.invoiceImageTime
					let invoiceImagesArr
					if(dataInfo.invoiceImages){
						invoiceImagesArr = dataInfo.invoiceImages.split(',')
					}else{
						invoiceImagesArr=''
					}
	   				detailInfo.invoiceImages = invoiceImagesArr
                    this.invoiceList = invoiceImagesArr
                    detailInfo.packageNumber = dataInfo.packageNumber
                    detailInfo.packageImageTime = dataInfo.packageImageTime
					let packageImagesArr
					if(dataInfo.packageImages){
						packageImagesArr = dataInfo.packageImages.split(',')
					}else{
						packageImagesArr = ''
					}
	   				detailInfo.packageImages = packageImagesArr
                    this.packageImagesList = packageImagesArr
					
                } else {
                    this.openMsgTip(res.body.message)
                    this.loadingorder = false
                }
            }, res => {
                this.openMsgTip(res.body.message)
                this.loadingorder = false
            })
         },
		confirm(){
			this.closeModal("modal1")
		},
		confirm2(){
			this.closeModal("modal2")
		},
		//发票图片放大
		invoicePreview(file) {
			this.invoiceImageUrl = file.url;
			this.invoiceVisible = true;
		},
		//快递照片放大
		packagePreview(file) {
			this.packageImageUrl = file.url;
			this.packageVisible = true;
		},
		//点击打开弹窗
		openinvoiceImg(){
			this.invoicefilelist = []
			this.openModal('modal1')
			this.invoiceform.invoiceNumber = ''
			this.invoiceform.invoiceCode = ''
			this.invoiceform.invoiceYear = ''
			this.invoiceform.invoiceImages = ''
		},
		//点击上传快递
		openpackageImg(){
			this.packagefilelist = []
			this.openModal('modal2')
			this.packageform.packageNumber = ''
			this.packageform.packageImages = ''
		},
		//提交上传发票
		submitForm(formName) {
			if(formName == 'invoiceform'){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.invoiceFun()
					} else {
						return false
					}
				})
			}else if(formName == 'packageform'){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.packageFun()
					} else {
						return false
					}
				})
			}
		},
		//上传发票
		invoiceFun(){
			let infoparms = this.invoiceform
			let params = {
				id:this.listId,
				invoiceNumber:infoparms.invoiceNumber,
				invoiceCode:infoparms.invoiceCode,
				invoiceYear:infoparms.invoiceYear,
				invoiceImages:infoparms.invoiceImages,

			}
			this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/payment/invoice',params).then(res => {
                if (res.body.success) {
					this.$message({type:'success',message:'上传成功'})
                   this.confirm()
				   this.detailInfo()
                } else {
                    this.openMsgTip(res.body.message)
                    this.loadingorder = false
                }
            }, res => {
                this.openMsgTip(res.body.message)
                this.loadingorder = false
            })
		},
		//上传快递信息
		packageFun(){
			let infoparms = this.packageform
			let params = {
				id:this.listId,
				packageNumber:infoparms.packageNumber,
				packageImages:infoparms.packageImages
			}
			console.log(params,'params')
			this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/payment/package',params).then(res => {
                if (res.body.success) {
				   this.$message({type:'success',message:'上传成功'})
                   this.confirm2()
				   this.detailInfo()
                } else {
                    this.openMsgTip(res.body.message)
                    this.loadingorder = false
                }
            }, res => {
                this.openMsgTip(res.body.message)
                this.loadingorder = false
            })
		},
		//限制图片大小
		beforeupload(file){
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
			const isLt1M = file.size / 1024 / 1024 < 1
			if (!isLt1M) {
				this.$message.error('上传图片大小不能超过 1M!');
			}
			if (!isJPG) {
				this.$message.error('请上传png或者jpg类型的图片');
			}
			return isLt1M && isJPG
		},
		//图片上传成功
		invoiceSuccess(res, file, fileList){
			this.ImgfileList(0,fileList)
		},
	
		//上传快递发票信息
		packageSuccess(res, file, fileList){
			this.ImgfileList(1,fileList)
		},
		ImgfileList(val,fileList){
			if(val== 0){
				let imgfileArr = []
				for (const key in fileList) {
					imgfileArr.push(process.env.PIC_PATH + fileList[key].response.data)
				}
				let imgfileList = imgfileArr.join(',')
				this.invoiceform.invoiceImages = imgfileArr.join(',')
			}
			if(val== 1){
				let imgfileArr = []
				for (const key in fileList) {
					imgfileArr.push(process.env.PIC_PATH + fileList[key].response.data)
				}
				let imgfileList = imgfileArr.join(',')
				this.packageform.packageImages = imgfileArr.join(',')
			}
			
		},
		invoiceRemove(file, fileList){
			this.ImgfileList(0,fileList)
		},
		//移除快递信息照片
		packageRemove(file, fileList) {
			this.ImgfileList(1,fileList)
		},
		//限制图片上传几张
		imgExceed(files, fileList){
			if(fileList.length === 3){
			  this.$message({type:'error',message:'最多上传三张图片'})
			}
		},
		closeModal(ref){
			this.$refs[ref].close()
			this.$store.dispatch('hideRailModal')
			//classlist.toggleScroll('open','#carRail',this);
		},
		closeModalMsg () {
			this.closeModal('modalMsg')
		},
		openModal(ref) {
			this.$refs[ref].open()
			console.log(classlist,'classlist')
			//classlist.toggleScroll('close','#carRail',this);
		},
		openMsgTip (message) {
			this.messageStr = message
			this.openModal('modalMsg')
		}
      }
}
</script>
<style scoped lang="scss">
/*和派单详情、救援单详情切换有关*/
	ul li {
		float: left;
		padding: 5px 10px;
		list-style: none;
	}

	ul {
		border: 1px solid #ccc;
	}

	li {
		border-right: 1px solid #ccc;
	}

	li.active {
		background-color: #000;
	}
/*派单详情状态相关*/
	.red_bg{
		background-color:rgba(201,9,1,0.3)!important;
		color:#f44336;
	}
	.green_bg{
		background-color:#DDFFDC!important;
		color:#309c34;
	}
	.yellow_bg{
		background-color:#FDF7DC!important;
		color:#ef6c00;
	}
.imgBox{display: flex;align-items: center;}
.imgStyle{width: 150px;height: 100px;margin-right: 10px;}
.invoiceformBox{width: 50%;margin: 0 auto;}

</style>
<style>
.invoiceformBox input[type="file"]{display: none;}
.invoiceformBox .el-upload--picture-card{width: 150px;height: 100px;line-height: 98px;}
.invoiceformBox .el-upload-list li{width: 150px;height: 100px;}
.invoiceformBox .el-date-editor.el-input{width: 100%;}
</style>



// WEBPACK FOOTER //
// PagePaymentListEdit.vue?0bf7d46b